import { paymentMethodCodes } from '../../../constants/paymentMethods';
import type { TransformedPaymentMethod } from '../../../models';
import { getMethod } from '../../../utils/paymentMethods';

const { KLARNA_ONE, KLARNA_PAY_LATER, KLARNA_PAY_NOW, KLARNA_SLICE_IT, KLARNA_SOFORT } =
  paymentMethodCodes;

export const getFirstAvailableKlarnaMethod = (paymentMethods: TransformedPaymentMethod[]) =>
  getMethod(paymentMethods, KLARNA_ONE) ||
  getMethod(paymentMethods, KLARNA_PAY_LATER) ||
  getMethod(paymentMethods, KLARNA_PAY_NOW) ||
  getMethod(paymentMethods, KLARNA_SLICE_IT) ||
  getMethod(paymentMethods, KLARNA_SOFORT) ||
  null;
